import { Box, Modal, Typography } from "@mui/material";
import React from "react";

const ApproveModa = ({ approveModal, setApproveModal ,handleControl}) => {
  return (
    <Modal
      open={approveModal}
      onClose={() => setApproveModal(!approveModal)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          height: 170,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "12px",
        }}
      >
        <Box display={"flex"} justifyContent={"center"}>
          <Typography
            mt={6}
            color={"#2E2E2E"}
            fontWeight={600}
            fontSize={"22px"}
            alignItems={"center"}
          >
            Are you sure you want to approve?
          </Typography>
        </Box>
        <Box display={"flex"} gap={2} justifyContent={"center"} padding={2}>
          <Box
            component={"button"}
            onClick={() => setApproveModal(!approveModal)}
            width={"100px"}
            p={"15px"}
            textAlign={"center"}
            borderRadius={2}
            border={"solid 1px #4C5A6A"}
            bgcolor={"#FFFFFF"}
            style={{
              cursor: "pointer",
            }}
          >
            Cancel
          </Box>
          <Box
            component={"button"}
            bgcolor={"#17DFBA"}
            width={"100px"}
            p={"15px"}
            textAlign={"center"}
            borderRadius={2}
            border={"none"}
            style={{
              cursor: "pointer",
            }}
            onClick={()=>handleControl("APPROVED")}
          >
            Send
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ApproveModa;
